module.exports = {
      id: "hexbackground-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#hexbackground",
      toString: function () {
        return this.url;
      }
    }